/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable react/jsx-no-constructed-context-values */
import React, { createContext, useState, useContext, ReactNode, Dispatch, SetStateAction } from 'react'

type HomeContextType = {
  scrollHeight: number
  setScrollHeight: ( height: number ) => void
  isCTABouncing: boolean
  setIsCTABouncing: Dispatch<SetStateAction<boolean>>
  onClickSubscribe: any
}

const HomeContext = createContext<HomeContextType>( {
  'scrollHeight': 0,
  'setScrollHeight': () => null,
  'isCTABouncing': false,
  'setIsCTABouncing': () => null,
  'onClickSubscribe': () => null,
} )

export const useHome = () => useContext( HomeContext )

type HomeProviderProps = {
  children: ReactNode
}

export const HomeProvider: React.FC<HomeProviderProps> = ( { children } ) => {
  const [ scrollHeight, setScrollHeight ] = useState( 0 )
  const [ isCTABouncing, setIsCTABouncing ] = useState( false )

  const onClickSubscribe = () => {
    window.scrollTo( { 'top': scrollHeight, 'behavior': 'smooth' } )
    setIsCTABouncing( false )
    setTimeout( () => setIsCTABouncing( true ), 400 )
  }

  return (
    <HomeContext.Provider
      value={{
        scrollHeight,
        setScrollHeight,
        isCTABouncing,
        setIsCTABouncing,
        onClickSubscribe
      }}
    >
      {children}
    </HomeContext.Provider>
  )
}
